import React, { Suspense, useEffect, useState } from 'react';
import { node, object } from 'prop-types';
import { ChatbotProvider, useChatbot } from '../../context/ChatbotContext';

// Lazy load the chatbot widget to avoid affecting initial page load
const ChatbotWidget = React.lazy(() => import('../ChatbotWidget/ChatbotWidget'));

const ChatbotWidgetWrapper = () => {
  const { isOpen, isEnabled, currentUser, toggleChatbot } = useChatbot();
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  // Avoid rendering React.lazy/Suspense during SSR.
  if (!isEnabled || !hasMounted) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ChatbotWidget isOpen={isOpen} onToggle={toggleChatbot} currentUser={currentUser} />
    </Suspense>
  );
};

const PageWithChatbot = ({ children, currentUser, ...props }) => {
  return (
    <ChatbotProvider currentUser={currentUser}>
      <div style={{ position: 'relative', minHeight: '100vh' }}>
        {children}
        <ChatbotWidgetWrapper />
      </div>
    </ChatbotProvider>
  );
};

PageWithChatbot.propTypes = {
  children: node.isRequired,
  currentUser: object,
};

export default PageWithChatbot;
